module.exports = __webpack_public_path__ + "img/bin.9c2bb0a2.svg";